import { render } from "./ImagesTable.vue?vue&type=template&id=6c5e583f&ts=true"
import script from "./ImagesTable.vue?vue&type=script&lang=ts"
export * from "./ImagesTable.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2114753346/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__